import './Main.css'

import React, { useEffect, useRef, useState } from 'react'
import { useWizard, WizardData } from './context'
import { useAppContext } from '@/context/app'
import { useForm, UseFormReturn } from 'react-hook-form'
import { addServerErrors } from '@/components/forms/common/FormBase'
import { FormData, QuickCreateMachineForm } from './types'

export const CreateMachineWizardStep3 = ({ onDone }: {
  onDone: (data: WizardData, form: UseFormReturn<FormData, any, undefined>) => Promise<void>
}) => {
  const { services, session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep, prevStep } = useWizard()
  const form = useForm<FormData>({
    defaultValues: wizardData.machine as any
  })

  const handle = (data: FormData): Promise<void> => {
    return onDone({
      ...wizardData,
      machine: data
    }, form)
  }

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <div>
    <QuickCreateMachineForm
      onSubmit={handle}
      services={services}
      form={form}
      translates={translates}
      formName='machine'
      readOnly={false}
    />
    <div className='right-btns'>
      <button className='btn btn-next' onClick={() => {
        updateWizardData({
          ...wizardData,
          machine: form.getValues()
        })
        prevStep()
      }}>{translates.for('popup.create_machine_wizard.prev')}</button>
      <button className='btn btn-next' onClick={() => {
        form.handleSubmit(handle)()
      }}>{translates.for('popup.create_machine_wizard.accept')}</button>
    </div>
  </div>
}

